import styled from 'styled-components'
import { ButtonStyle } from 'Components/Shared/Button/ButtonStyle'
import { TitleStyle } from 'Components/Shared/Title/TitleStyle'

export const PopupWindowStyle = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  font-weight: 500;
  font-family: Helvetica, sans-serif;
  justify-content: center;
  padding: 2em 2em 2em 2em;
  @media (max-width: 600px) {
    font-size: small;
    width: 90%;
    overflow-y: scroll;
  }
  overflow-y: scroll;
  width: 36%;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;

  background-color: ${(props) =>
    props.theme.planInfo?.backgroundColor ||
    props.theme.banner?.backgroundColor ||
    `#377460`};

  color: ${(props) =>
    props.theme.planInfo?.color || props.theme.banner?.color || `white`};

  ${ButtonStyle} {
    font-family: Helvetica, sans-serif;
    align-self: center;
    background-color: ${(props) =>
      props.theme.planInfo?.buttonBackground || 'black'};
    color: ${(props) => props.theme.planInfo?.buttonText || 'white'};
    border-radius: ${(props) =>
      props.theme.planInfo?.buttonBorderRadius || 0}px;
    width: max-content;
    margin-top: 2em;
    margin-bottom: 3em;
    @media (max-width: 600px) {
      font-size: small;
    }
  }

  ${TitleStyle} {
    font-family: Helvetica, sans-serif;
    color: ${(props) =>
      props.theme.planInfo?.color || props.theme.banner?.color || `white`};
  }

  .footerText {
    text-align: center;
    font-size: small;
  }
`

export const PopupTitle = styled.div`
  font-family: Helvetica, sans-serif;
  img {
    width: 110px;
  }
  @media (max-width: 600px) {
    padding-top: 0em;
    padding-bottom: 0em;
  }
  padding-top: 6em;
  // padding-bottom: 4em;
  text-align: center;
`
export const FeatureList = styled.p`
  font-family: Helvetica, sans-serif;
  text-align: start;
`
export const TableInfo = styled.p`
  font-family: Helvetica, sans-serif;
  align-self: center;
  width: 70%;
`
